var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 65,
    viewBox: "0 0 81 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0028 0.695557H8.0267C3.61201 0.695557 0.0401335 4.30757 0.0401335 8.72226V24.7757C4.45482 24.7757 8.0267 28.3877 8.0267 32.8024C8.0267 37.217 4.45482 40.8291 0 40.8291V56.8825C0 61.2971 3.61201 64.9091 8.0267 64.9091H72.2403C76.655 64.9091 80.267 61.2971 80.267 56.8825V8.72226C80.267 4.30757 77.0162 0.695557 73.0028 0.695557ZM72.2403 56.8825H8.0267V46.6885C12.8026 43.9193 16.0534 38.702 16.0534 32.8024C16.0534 26.8626 12.8427 21.6854 8.06683 18.9162L8.0267 8.72226H72.2403V56.8825ZM27.5717 47.4912L20.9096 35.9328L24.642 34.9294L29.6988 38.9026L39.2907 36.3341L29.6587 19.6386L35.2773 18.1135L51.3709 33.1234L61.1634 30.5147C63.2103 29.9529 65.3373 31.197 65.8992 33.2438C66.4209 35.2906 65.2169 37.4177 63.13 38.0197L27.5717 47.4912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.beb91ef06c5584631d0c0fcdb7a2c50f.svg";
export { ForwardRef as ReactComponent };